<script>
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueEditor from '@/components/vue2-editor/VueEditor'
import FileUploadZone from '@/components/FileUploadZone'
import VueUtils from '@/utils/vueUtils'
import StringUtils from '@/utils/stringUtils'
import DOMUtils from '@/utils/DOMUtils'

export default
{
    name: 'fields-validator',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='fields-validator'>
                { this.$slots.default }
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        getFieldChildren ()
        {
            return [...VueUtils.getChildrenOfType(this, FloatingLabelTextInput), ...VueUtils.getChildrenOfType(this, VueEditor),
                ...VueUtils.getChildrenOfType(this, FileUploadZone)]
        },

        validate ()
        {
            var isValid = true
            const fields = this.getFieldChildren()

            for (const field of fields)
            {
                var error = ''

                if (VueUtils.isInstanceOfComponent(field, FileUploadZone))
                {
                    if (field.filesUploadedCount < field.validation)
                    {
                        error = 'Vous devez fournir au moins ' + field.validation + ' image' + (field.validation > 1 ? 's' : '')
                    }
                }
                else
                {
                    if (!DOMUtils.isElementVisible(field.$el)) continue
                    if (field.optional && StringUtils.isEmptyString(field.inputText)) continue

                    switch (field.validation || field.type)
                    {
                        case 'not-empty':
                            error = this.validateNotEmpty(field.inputText)
                            break
                        case 'email':
                            error = this.validateMail(field.inputText)
                            break
                        case 'tel':
                        case 'phone':
                            error = this.validatePhone(field.inputText)
                            break
                        case 'number':
                            error = this.validateNumber(field.inputText)
                            break
                        default: break
                    }
                }
                
                if (error)
                {
                    field.setErrorMessage(field.validationHint || error)
                    isValid = false
                }
            }

            return isValid
        },

        validateNotEmpty (val)
        {
            if (StringUtils.isEmptyString(val)) return 'Nous avons besoin que vous renseigniez ce champ'
        },

        validateMail (val)
        {
            if (!StringUtils.isValidEmail(val)) return 'Vous devez fournir votre courriel'
        },

        validatePhone (val)
        {
            if (StringUtils.getFrenchPhoneNumbersInString(val).length < 1)
            {
                return 'Nous avons besoin d\'un numéro de téléphone valide'
            }
        },

        validateNumber (val)
        {
            if (isNaN(val) || StringUtils.isEmptyString(val))
            {
                return 'Vous devez fournir un numéro valide'
            }
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.fields-validator
{
}
</style>


// WEBPACK FOOTER //
// src/components/FieldsValidator.vue